<template>
    <div>11</div>
</template>
<script>
export default {
    name: 'WorkbenchIndex',
    data() {
        return {

        }
    },
    computed: {
        menuList() {
            return this.$store.state.menuList || [];
        }
    },
    watch: {
        menuList: {
            handler(newVal) {
                if (newVal.length) {
                    this.replacePage();
                }
            },
            deep: true
        }
    },
    mounted() {
        this.replacePage();
    },
    methods: {
        replacePage() {
            const _menuList = this.menuList;
            // 打平 menuList（含 subMenuList）
            const flatMenus = _menuList.reduce((acc, item) => {
                if (item.subMenuList && item.subMenuList.length) {
                    return acc.concat(item.subMenuList);
                }
                return acc.concat(item);
            }, []);
            const hasWork = flatMenus.some(item => item.link === '/workbench/work');
            const hasDashboard = flatMenus.some(item => item.link === '/workbench/dashboard');
            if (hasWork) {
                this.$router.replace({ path: '/workbench/work' });
            } else if (hasDashboard) {
                this.$router.replace({ path: '/workbench/dashboard' });
            }
        }
    }
}
</script>
<style lang="scss" scoped></style>
